import React from "react";
import './index.css'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const closeSvgPath: string = require("./close.svg");

export type PopupMessage = {
    header: string;
    body: string;
}

type PopupProps = {
    message: PopupMessage;
    handlePopupClose: () => void;
}

const Popup = ({message, handlePopupClose}: PopupProps) => {
    return (
        <>
            <div className="popup" role="dialog" aria-label="popup" aria-modal={true}>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-header-left">{message.header}</div>
                        <div className="popup-header-right">
                            <button onClick={handlePopupClose}
                                    data-testid="popupClose"
                                    className="popup-close"
                                    role="button">
                                <img alt="info close" src={closeSvgPath}/>
                            </button>
                        </div>
                    </div>
                    <div className="popup-body">
                        {message.body}
                    </div>
                </div>

            </div>
            <span className="pointer"/>
        </>
    );
};

export default Popup;